import DTO from './DTO';

class FilterDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'DOOR_UPPER_UNKNOWN',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.DOOR_UPPER_UNKNOWN',
      },
      {
        name: 'DOOR_UPPER_OPENED',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.DOOR_UPPER_OPENED',
      },
      {
        name: 'DOOR_UPPER_CLOSED',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.DOOR_UPPER_CLOSED',
      },
      {
        name: 'DOOR_LOWER_UNKNOWN',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.DOOR_LOWER_UNKNOWN',
      },
      {
        name: 'DOOR_LOWER_OPENED',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.DOOR_LOWER_OPENED',
      },
      {
        name: 'DOOR_LOWER_CLOSED',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.DOOR_LOWER_CLOSED',
      },

      {
        name: 'DOOR_LOCK_LOWER_ERROR',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.DOOR_LOCK_ERROR',
      },
      {
        name: 'DOOR_LOCK_LOWER_UNKNOWN',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.DOOR_LOCK_UNKNOWN',
      },
      {
        name: 'DOOR_LOCK_LOWER_LOCKED',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.DOOR_LOCK_LOCKED',
      },
      {
        name: 'DOOR_LOCK_LOWER_UNLOCKED_CLOSED',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.DOOR_LOCK_UNLOCKED_CLOSED',
      },
      {
        name: 'DOOR_LOCK_LOWER_UNLOCKED_OPENED',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.DOOR_LOCK_UNLOCKED_OPENED',
      },

      {
        name: 'DOOR_LOCK_UPPER_ERROR',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.DOOR_LOCK_ERROR',
      },
      {
        name: 'DOOR_LOCK_UPPER_UNKNOWN',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.DOOR_LOCK_UNKNOWN',
      },
      {
        name: 'DOOR_LOCK_UPPER_LOCKED',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.DOOR_LOCK_LOCKED',
      },
      {
        name: 'DOOR_LOCK_UPPER_UNLOCKED_CLOSED',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.DOOR_LOCK_UNLOCKED_CLOSED',
      },
      {
        name: 'DOOR_LOCK_UPPER_UNLOCKED_OPENED',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.DOOR_LOCK_UNLOCKED_OPENED',
      },

      {
        name: 'PSS_UNKNOWN',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.PSS_UNKNOWN',
      },
      {
        name: 'PSS_ERROR',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.PSS_ERROR',
      },
      {
        name: 'PSS_UNREGISTERED',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.PSS_UNREGISTERED',
      },
      {
        name: 'PSS_OK',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.PSS_OK',
      },
      {
        name: 'PS_ERROR',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.PS_ERROR',
      },
      {
        name: 'PS_PAPER_EMPTY',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.PS_PAPER_EMPTY',
      },
      {
        name: 'PS_PAPER_LOW',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.PS_PAPER_LOW',
      },
      {
        name: 'PS_UNKNOWN',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.PS_UNKNOWN',
      },
      {
        name: 'PS_OK',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.PS_OK',
      },
      {
        name: 'POWER_ERROR',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.POWER_ERROR',
      },
      {
        name: 'POWER_LOW_POWER',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.POWER_LOW_POWER',
      },
      {
        name: 'POWER_UNKNOWN',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.POWER_UNKNOWN',
      },
      {
        name: 'POWER_OK',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.POWER_OK',
      },
      {
        name: 'PAYMENT_ERROR',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.PAYMENT_ERROR',
      },
      {
        name: 'PAYMENT_UNKNOWN',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.PAYMENT_UNKNOWN',
      },
      {
        name: 'PAYMENT_IDLE',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.PAYMENT_IDLE',
      },
      {
        name: 'PAYMENT_WAIT_CARD',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.PAYMENT_WAIT_CARD',
      },
      {
        name: 'PAYMENT_WAIT_BANK',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.PAYMENT_WAIT_BANK',
      },
      {
        name: 'PAYMENT_COMPLETE',
        type: Boolean,
        validators: [],
        labelKey: 'parking.meter.PAYMENT_COMPLETE',
      },
      {
        name: 'DS_NO_INIT_DETECT_VIOLATION',
        type: Boolean,
        validators: [],
        labelKey: 'cameras.DS_NO_INIT_DETECT_VIOLATION',
      },
      {
        name: 'DS_NO_INIT_DETECTION',
        type: Boolean,
        validators: [],
        labelKey: 'cameras.DS_NO_INIT_DETECTION',
      },
      {
        name: 'DS_NO_INIT_CAMERA',
        type: Boolean,
        validators: [],
        labelKey: 'cameras.DS_NO_INIT_CAMERA',
      },
      {
        name: 'DS_UNKNOWN',
        type: Boolean,
        validators: [],
        labelKey: 'cameras.DS_UNKNOWN',
      },
      {
        name: 'DS_OK',
        type: Boolean,
        validators: [],
        labelKey: 'cameras.DS_OK',
      },
      {
        name: 'DS_ERROR',
        type: Boolean,
        validators: [],
        labelKey: 'cameras.DS_ERROR',
      },
      {
        name: 'PRS_NO',
        type: Boolean,
        validators: [],
        labelKey: 'cameras.PRS_NO',
      },
      {
        name: 'PRS_YES',
        type: Boolean,
        validators: [],
        labelKey: 'cameras.PRS_YES',
      },
      {
        name: 'PRS_UNKNOWN',
        type: Boolean,
        validators: [],
        labelKey: 'cameras.PRS_UNKNOWN',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    const data = {
      id: this.id,
      host: this.host,
    };

    return data;
  }

  getLoginData() {
    return {
      login: this.login,
      password: this.password,
    };
  }
}

export default FilterDTO;
